var map = {
	"./ID.webp": 778,
	"./INDO.webp": 779,
	"./MY.webp": 780,
	"./TH.webp": 781,
	"./VN.webp": 782,
	"./malaysia.webp": 783
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 395;
module.exports = webpackAsyncContext;